import { App, Button, DatePicker, Form, InputNumber, Modal, Typography } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { StudentActions } from "./StudentActions.jsx";

export function CourseSetupModal({ open, title, initial, saving = false, onClose, onLater, onSave }) {
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState(null);
  const { modal } = App.useApp();
  useEffect(() => {
    if (open) { setDate(initial?.startDate || ""); setAmount(initial?.firstMonthAdjustment ?? null); }
  }, [open, initial]);
  const valid = Boolean(date) && amount !== null && amount !== "" && Number.isFinite(Number(amount)) && Number(amount) >= 0;
  const later = () => {
    if (date || amount !== null) {
      modal.confirm({ className: "student-management-modal", title: "입력한 날짜와 금액을 비우고 나중에 입력할까요?", okText: "나중에 입력", cancelText: "계속 입력",
        onOk: onLater });
    } else onLater();
  };
  return <Modal open={open} title="수업 등록" width={480} className="student-management-modal student-course-setup-modal" onCancel={onClose}
    footer={<StudentActions>
      <Button disabled={saving} onClick={onLater ? later : onClose}>{onLater ? "나중에 입력" : "취소"}</Button>
      <Button type="primary" loading={saving} disabled={!valid} onClick={() => onSave({ startDate: date, firstMonthAdjustment: Number(amount) })}>저장</Button>
    </StudentActions>} destroyOnHidden>
    <Typography.Paragraph strong>{title}</Typography.Paragraph>
    <Form layout="vertical" disabled={saving}>
      <Form.Item className="student-course-setup-field" label="첫 수업 시작일" required>
        <DatePicker aria-label="첫 수업 시작일" value={date ? dayjs(date) : null} onChange={value => setDate(value ? value.format("YYYY-MM-DD") : "")}
          format="YYYY-MM-DD" placeholder="날짜 선택" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item className="student-course-setup-field" label="첫 달 조정 금액" required>
        <InputNumber aria-label="첫 달 조정 금액" value={amount} onChange={setAmount} min={0} max={9999999999.99} precision={2}
          formatter={value => String(value ?? "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={value => (value ?? "").replace(/,/g, "")}
          addonAfter="원" style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  </Modal>;
}
